var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-decoration-underline",on:{"click":_vm.goToPlan}},[_vm._v(" "+_vm._s(_vm.planName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }